import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { CustomEventEnums } from "../../shared/utilities/enums/customEventEnums";
import { StringEnums } from "../../shared/utilities/enums/stringEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { TypeUtils } from "../../shared/utilities/typeUtils";
import { IReviewWidgetOptionBase, ReviewWidgetOptionBase } from "./reviewWidgetOptionBase";

export interface IReviewWidgetPagerRatingsFilterOption extends IReviewWidgetOptionBase {
    update: (isSelected: boolean, isDisabled: boolean) => void;
}

export class ReviewWidgetPagerRatingsFilterOption extends ReviewWidgetOptionBase implements IReviewWidgetPagerRatingsFilterOption {
    public isSelected: boolean;
    constructor(public htmlElement: HTMLElement, isDisabled: boolean, isSelected: boolean) {
        super(htmlElement, isDisabled, isSelected);

        this.updateIsSelected(isSelected);
    }

    setIsSelectedCssClass():void{
        console.log(`ReviewWidgetPagerRatingsFilterOption: setActiveCssClass - ${this.isSelected}`);
        if(this.isSelected){
            this.htmlElement.classList.add(StringEnums.CssClass.LbActive);
        }else{
            this.htmlElement.classList.remove(StringEnums.CssClass.LbActive);
        }
    }

    updateIsSelected(isSelected: boolean):void{
        this.isSelected = isSelected;
        this.setIsSelectedCssClass();
    }

    update(isSelected: boolean, isDisabled: boolean):void{
        this.updateIsSelected(isSelected);
        this.updateIsDisabled(isDisabled);
    }
}